/**
 * Remove the unit from the CSS length value and return it as a number. Reverses the process,
 * that Carbon uses, to add the unit after the number value. Useful for extracting values in pixels,
 * that are otherwise not accessible in Carbon. It should work for every valid number except for
 * negative zero, as it's value is lost at the beginning in the conversion to the string:
 * `String(-0) === '0'`
 */
const removeUnit = (value: string, unit: string): number => {
  // Value must end with the unit without any surrounding characters.
  const unitIndex = Math.max(0, value.length - unit.length);
  if (value.slice(unitIndex) !== unit) {
    throw new Error('Invalid unit');
  }
  // Number is the part of the value before the unit.
  const numberString = value.slice(0, unitIndex);
  // Empty and whitespace-only strings must be filtered out, as they will be converted to zero.
  // In CSS number must be present even if it's zero.
  if (numberString.match(/^\s*$/)) {
    throw new Error('Invalid number');
  }
  // Parse the number without any surrounding characters.
  const number = Number(numberString);
  // Value must be the valid number, except NaN
  if (Number.isNaN(number) && numberString !== String(NaN)) {
    throw new Error('Invalid number');
  }
  return number;
};

export default removeUnit;
